module.exports = __webpack_public_path__ + "img/avi.8c6d24f3.png";